import { Component, Input, Output, EventEmitter } from '@angular/core';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-files-viewer',
  templateUrl: './files-viewer.component.html',
  standalone:false
})
export class FilesViewerComponent {
  @Input() files: any = [];
  @Input() cols = 1;
  @Input() downloadWithApi = false;
  @Input() enableDownload = true;
  @Input() viewFile = false;
  @Input() isLessonFile = false;
  @Input() showDelete = false;
  @Output() viewFileEvent = new EventEmitter<any>();
  @Output() isFileDownloaded = new EventEmitter<any>();
  @Output() isFileDeleted = new EventEmitter<any>();
  docsEditable = false;
  requestToken!: string;

  constructor() { }

  fileType(fileName:any) {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'mp4':
        return 'mp4';
      case 'jpg':
        return 'jpg';
      case 'jpeg':
        return 'jpeg';
      case 'png':
        return 'png';
      case 'doc':
      case 'docx':
      case 'wpd':
      case 'tex':
        return 'doc';
      case 'xlsx':
      case 'xls':
        return 'xls';
      case 'zip':
      case 'rar':
        return 'zip';
      case 'ppt':
      case 'pptx':
        return 'pptx';
      case 'svs':
      case 'tif':
      case 'ndpi':
      case 'scn':
      case 'mrxs':
      case 'svslide':
      case 'bif':
        return 'wsi';
      default:
        return false;
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes:any, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  downloadImg(file: any) {
    if (this.isLessonFile) {
      this.isFileDownloaded.emit(file)
    } else {
      saveAs(file.path, file.name);
    }
  }
}
